import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="container-main py-12">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>

        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Terms of Service</h1>
          <p className="text-slate-500 mb-8">Last updated: January 2026</p>

          <div className="prose prose-slate max-w-none">
            <h2 className="text-xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-slate-600 mb-4">
              By accessing and using SpotFinder ("the Service"), you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our Service.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. Description of Service</h2>
            <p className="text-slate-600 mb-4">
              SpotFinder is a marketplace platform that connects parking space owners ("Hosts") with drivers 
              seeking parking ("Drivers"). We facilitate the booking and payment process but are not responsible 
              for the actual parking spaces listed on our platform.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. User Accounts</h2>
            <p className="text-slate-600 mb-4">
              You must create an account to use certain features of our Service. You are responsible for:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Providing accurate and complete information</li>
              <li>Notifying us immediately of any unauthorized use</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Host Responsibilities</h2>
            <p className="text-slate-600 mb-4">
              As a Host, you agree to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Provide accurate descriptions and photos of your parking space</li>
              <li>Ensure your parking space is available during booked times</li>
              <li>Maintain a safe and accessible parking environment</li>
              <li>Comply with all local laws and regulations</li>
              <li>Have appropriate insurance coverage for your property</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Driver Responsibilities</h2>
            <p className="text-slate-600 mb-4">
              As a Driver, you agree to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Use parking spaces only during your booked time</li>
              <li>Follow any access instructions provided by the Host</li>
              <li>Not damage the property or surrounding areas</li>
              <li>Have valid vehicle registration and insurance</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Payments and Fees</h2>
            <p className="text-slate-600 mb-4">
              SpotFinder charges a service fee of 15% to Drivers and 5% to Hosts on each transaction. 
              Payments are processed securely through Stripe. Hosts receive payouts according to their 
              selected payout method.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Cancellations and Refunds</h2>
            <p className="text-slate-600 mb-4">
              Cancellation policies vary by listing. Please review the cancellation policy before booking. 
              Refunds are processed according to the applicable cancellation policy.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">8. Limitation of Liability</h2>
            <p className="text-slate-600 mb-4">
              SpotFinder is not liable for any damages, injuries, or losses arising from the use of 
              parking spaces listed on our platform. We are a marketplace facilitator and do not own, 
              operate, or control the parking spaces.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">9. Termination</h2>
            <p className="text-slate-600 mb-4">
              We reserve the right to suspend or terminate your account at any time for violation of 
              these terms or for any other reason at our sole discretion.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">10. Contact Us</h2>
            <p className="text-slate-600 mb-4">
              If you have questions about these Terms, please contact us at support@spotfinder.co
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
